import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import "../styles/components/BookingBreadcrumb.css";

const BookingBreadcrumb = ({ category, typeName, onResetType, onResetCategory, compactView = false }) => {
    return (
        <Box className={`breadcrumb-container ${compactView ? 'compact-view' : ''}`} overflowX="auto" whiteSpace="nowrap">
            <Breadcrumb separator="›" spacing="12px" className="breadcrumb-nav">
                <BreadcrumbItem>
                    <BreadcrumbLink 
                        as={Link} 
                        to="#" 
                        onClick={onResetCategory}
                        className="breadcrumb-link"
                    >
                        Categories
                    </BreadcrumbLink>
                </BreadcrumbItem>
                {category && (
                    <BreadcrumbItem>
                        <BreadcrumbLink 
                            as={Link} 
                            to="#" 
                            onClick={onResetType}
                            className="breadcrumb-link"
                        >
                            {category}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                )}
                {typeName && (
                    <BreadcrumbItem isCurrentPage>
                        <BreadcrumbLink 
                            as={Link} 
                            to="#"
                            className="breadcrumb-link current"
                        >
                            {typeName}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                )}
            </Breadcrumb>
        </Box>
    );
};

export default BookingBreadcrumb;